import { useTranslation } from "react-i18next";
import type { TFunction } from "i18next";
import type { SampleCardDto } from "@hisense/shared";
import { Modal } from "@/components/ui/Modal";
import { Button } from "@/components/ui/Button";
import { ApiClientError, getLocalizedError } from "@/lib/api";
import { buildSampleCardHtml, printSampleCard } from "@/lib/printSampleCard";
import { SaveAsPdfHint } from "@/components/domain/SaveAsPdfHint";
export function cardError(error:unknown,t:TFunction):string {
  if(error instanceof ApiClientError&&error.code.startsWith("sample_card_")){
    const key=`cardWorkspace.${error.code}`;if(t(key)!==key)return t(key);
  }
  return getLocalizedError(error,t,"samples.errorSaveCard");
}
export function SampleCardPrintPreview({card,onClose}:{card:SampleCardDto;onClose:()=>void}) {
  const {t}=useTranslation();
  return <Modal title={`${t("cardWorkspace.printPreview")} · ${card.sampleCardNumber}`} closeLabel={t("common.close")} onClose={onClose}>
    <div className="flex flex-wrap items-center justify-between gap-3 border-b border-line p-3"><SaveAsPdfHint /><Button onClick={()=>printSampleCard(card)}>{t("common.print")}</Button></div>
    <iframe title={t("cardWorkspace.printPreview")} sandbox="allow-same-origin" srcDoc={buildSampleCardHtml(card)} className="min-h-[65dvh] w-full flex-1 bg-surface"/>
  </Modal>;
}
